<template>
    <FormSection title="Authorized Contacts" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <div class="d-flex justify-content-end" v-if="!isReOrderRequested && !showContactForm">
                    <button class="btn btn-primary mb-2" @click="requestReOrder()" v-if="totalContacts > 1">
                        Reorder Contacts
                    </button>
                    <button
                        class="btn btn-primary ms-2 mb-2"
                        @click="openAddContact()"
                        v-if="totalContacts < contactLimit"
                    >
                        Add Contact
                    </button>
                </div>
                <div class="d-flex justify-content-end" v-if="isReOrderRequested">
                    <button class="btn btn-primary mb-2" @click="confirmReOrder()" v-if="totalContacts > 1">
                        <i class="fa fa-spinner fa-spin" v-if="isSavingReOrder"></i>
                        {{ !isSavingReOrder ? "Save Reorder" : "Saving Reorder" }}
                    </button>
                    <button class="btn btn-outline-primary ms-2 mb-2" @click="cancelReOrder()">Cancel</button>
                </div>
                <div
                    :class="`material-card my-2 animated ${showContactForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`"
                    v-if="showContactForm"
                >
                    <PatientAuthorizedContactsForm
                        :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                        :is-palliative="isApplicationPalliative"
                        :patient-primary-address="patientPrimaryAddress"
                        :relationships-enum="relationshipsEnum"
                        :contact-roles-enum="contactRolesEnum"
                        :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                        :contact="contact"
                        :is-editable="true"
                        :is-loading="isLoading"
                        ref="addContact"
                    />
                    <footer class="d-flex justify-content-center my-2" v-if="!isLoading">
                        <button type="button" class="btn btn-primary me-2" @click="addContact()">Add Contact</button>
                        <button type="button" class="btn btn-outline-primary" @click="closeAddContact()">Cancel</button>
                    </footer>
                </div>
                <PatientAuthorizedContactsList
                    ref="contactList"
                    :is-re-order-requested="isReOrderRequested"
                    :patient-primary-address="patientPrimaryAddress"
                    v-model:total-contacts="totalContacts"
                    :patient-id="patientId"
                    :is-palliative="isApplicationPalliative"
                    v-model:cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                    :relationships-enum="relationshipsEnum"
                    :contact-roles-enum="contactRolesEnum"
                    :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                    :update-contact="updateAuthorizedContact"
                    :delete-contact="deleteAuthorizedContact"
                    :get-authorized-contacts="getAuthorizedContacts"
                    :isExternalReferral="isExternalReferral"
                />
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientAuthorizedContacts.ts"></script>
